import { createSelector } from 'reselect';

const sliceSelector = (state: any): any => state['router'];

export const pathSelector = createSelector(sliceSelector, (slice: any) =>
  slice && slice.location.pathname ? slice.location.pathname : '',
);
